import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/weibo': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M407 177.6C414.6 153.6 393.6 130.8 369.6 135.9 347.6 140.7 340.8 107.8 362.5 103.1 412.6 92.2 454.8 140.2 439 187.9 432.2 209.1 400.2 198.7 407 177.6zM214.8 446.7C108.5 446.7 0 395.3 0 310.4 0 266.1 28 215 76.3 166.7 176 67 279.5 65.8 249.9 161 245.9 174.1 262.2 166.7 262.2 167 341.7 133.4 402.7 150.2 376.2 218.4 372.5 227.8 377.3 229.3 384.5 231.5 520.2 273.8 419.3 446.7 214.8 446.7zM358.5 300.4C353.1 244.7 280 206.4 195.1 214.7 110.3 223.3 46.3 275 51.7 330.7S130.2 424.7 215.1 416.4C299.9 407.8 363.9 356.1 358.5 300.4zM347.9 35.1C322 40.7 331.1 78.8 356.2 73.4 428.5 58.2 491 126.2 467.9 197.4 460.5 221.6 497 234.4 505.3 209.4 537.2 109.6 450.2 13.5 347.9 35.1zM269.4 346.1C252.3 384.9 202.6 406.1 160.3 392.4 119.5 379.3 102.3 339 120 302.7 137.7 267.3 183.1 247.3 223.4 257.6 265.4 268.4 286.5 307.8 269.4 346.1zM183.1 316.1C170.2 310.7 153.1 316.4 145.1 329 136.8 341.9 140.8 357 153.7 363 166.8 369 184.5 363.3 192.8 350.1 200.8 337 196.5 321.8 183.1 316.1zM215.7 302.7C210.6 301 204.3 303.3 201.4 308.1 198.5 313.2 200 318.7 205.1 321 210.2 323 216.8 320.7 219.7 315.6 222.5 310.4 220.8 304.7 215.7 302.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/weibo.js
// module id = f8oY
// module chunks = 144